import styled from '@emotion/styled'
import { BREAKPOINTS } from 'utils/styled'

export const SPartnerAction = styled.div`
  display: flex;
  @media ${BREAKPOINTS.MD.max} {
    flex-direction: column;
    margin-right: calc(-5% * (100 / 90));
  }
`

export const SLeftDiv = styled.div`
  flex-basis: 50%;
  flex-shrink: 1;
`

export const SRightDiv = styled.div`
  flex-basis: 50%;
  margin-left: 5.4375rem;
  margin-top: 11rem;
  position: relative;
  margin-right: var(--p-content);
  margin-right: 5%;

  @media ${BREAKPOINTS.MD.max} {
    margin-top: 1.5rem;
    margin-left: 0;
  }
`
